import { comments } from '@/mocks/comments';

const hotComments = [...comments]
  .sort((a, b) => b.likes - a.likes)
  .slice(0, 6);

const leftCol = hotComments.filter((_, i) => i % 3 === 0);
const midCol = hotComments.filter((_, i) => i % 3 === 1);
const rightCol = hotComments.filter((_, i) => i % 3 === 2);

function CommentCard({ comment }: { comment: typeof comments[0] }) {
  return (
    <div className="bg-background-50 rounded-2xl p-5">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
          <img src={comment.avatar} alt={comment.username} className="w-full h-full object-cover" />
        </div>
        <div>
          <div className="text-sm font-label font-medium text-foreground-900">{comment.username}</div>
          <div className="text-xs text-foreground-500">@{comment.username}</div>
        </div>
      </div>
      <p className="text-sm text-foreground-700 leading-relaxed">
        &ldquo;{comment.content}&rdquo;
      </p>
      <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-thumb-up-line"></i> {comment.likes}
        </span>
        <span>{comment.date}</span>
      </div>
    </div>
  );
}

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 text-xs font-label font-medium bg-accent-100 text-accent-700 rounded-full mb-4">
            瓜友热评
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900 leading-tight">
            万千瓜友
          </h2>
          <p className="text-2xl md:text-4xl font-heading font-black text-foreground-900 leading-tight">
            在线开聊
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="flex flex-col gap-5">
            {leftCol.map((c) => (
              <CommentCard key={c.id} comment={c} />
            ))}
          </div>
          <div className="flex flex-col gap-5 md:mt-8">
            {midCol.map((c) => (
              <CommentCard key={c.id} comment={c} />
            ))}
          </div>
          <div className="flex flex-col gap-5 md:mt-4">
            {rightCol.map((c) => (
              <CommentCard key={c.id} comment={c} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}